import React, { ReactNode, ReactElement } from 'react';
import classes from './FullWidthCta.module.scss';
import A from 'components/atoms/A/A';
import Button from 'components/atoms/Button/Button';
import Txt from 'components/atoms/Txt/Txt';
import Heading from 'components/atoms/Heading/Heading';

export interface Props {
  title?: string | ReactElement;
  children?: ReactNode;
  ctaText?: string;
  ctaLink?: string;
}

const FullWidthCta: React.FC<Props> = ({ title, children, ctaText, ctaLink }) => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.root}>
        {title && (
          <Heading level={3} uppercase className={classes.title}>
            {title}
          </Heading>
        )}
        {children && (
          <Txt component="p" className={classes.description}>
            {children}
          </Txt>
        )}
        {ctaText && ctaLink && (
          <Button
            component={A}
            href={ctaLink}
            type="submit"
            className={classes.ctaButton}
            color="secondary"
            buttonType="secondary"
          >
            <Txt>{ctaText}</Txt>
          </Button>
        )}
      </div>
    </div>
  );
};

export default FullWidthCta;
